<div *ngIf="!src" class="bo-container container-fluid no-gutters">
  <q-bodisplay  view="edit" [param]="param" admin-gridster="bodisplay" (sendEvent)="BoSaved($event)"></q-bodisplay>
</div>
<iframe id="iframe1" *ngIf="src" class="frameview" [src]="src" frameborder="0" (load)="onLoad()"></iframe>
